document.addEventListener('DOMContentLoaded', () => {
  
  const tabs = document.querySelectorAll('.calc-tab');
  const ex1CartTotalElement = document.getElementById('ex1-cart-total');
  const ex1OptionElements = document.querySelectorAll('#calc-example-1 .ex1-option');
  const payoutValueElements = {
    ex1: document.querySelector('[data-target-payout="ex1"]'),
    ex2: document.querySelector('[data-target-payout="ex2"]'),
    ex3: document.querySelector('[data-target-payout="ex3"]')
  };
  const payoutDetailsElements = {
    ex1: document.getElementById('ex1-details'),
    ex2: document.getElementById('ex2-details'),
    ex3: document.getElementById('ex3-details')
  };
  const toggleDetailButtons = document.querySelectorAll('.payout-details-toggle');
  const premiumPriceInput = document.getElementById('premium-price');
  const ex2OptionElements = document.querySelectorAll('.ex2-option');
  const sidebarToggle = document.querySelector('.calc-sidebar');
  const calcContent = document.querySelector('.calc-content');
  const tabNumberElements = document.querySelectorAll('.tab-number');

  // Pre-computed Ex2 base payout
  const basePayoutEx2 = parseFloat(payoutValueElements.ex2.textContent.replace('$', '')) || 0;

  // Constants & rates
  const currencySymbol = '$';
  const basePrice = 150;
  const royaltyRate = 0.125;
  const premiumRate = 0.75;
  const otherItemsRate = 0.3;
  const affiliateCommissionPercentage = 17.5;
  const standardAffiliateCommission = basePrice * (affiliateCommissionPercentage / 100);

  // State
  let isAffiliate = true;
  const selectedProductsEx1 = { lady: true, butt: false, mouth: true };
  const selectedProductsEx2 = { lady: true, butt: false, mouth: false };

  // Helper: format number as currency
  const formatCurrency = (value) => {
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) return `${currencySymbol}0.00`;
    return `${currencySymbol}${numberValue.toFixed(2)}`;
  };

  // Core calculation & UI update
  function activatePopText() {
    const popTextElement = document.querySelector('.pop-up-message');
    if (popTextElement) {
        popTextElement.classList.add('active-animation');

        setTimeout(() => {
            popTextElement.classList.remove('active-animation');
        }, 2000);
    }
  };

  const calculatePayouts = () => {
    // --- Example 1 ---
    const royaltyPerItemEx1 = basePrice * royaltyRate;
    const commissionPerItemEx1 = isAffiliate ? standardAffiliateCommission : 0;
    let selectedCountEx1 = 0;
    let totalPayoutEx1 = 0;
    let detailsHtmlEx1 = '<div class="payout-details-grid">';

    for (const key of Object.keys(selectedProductsEx1)) {
      if (selectedProductsEx1[key]) {
        selectedCountEx1++;
        const itemPayout = royaltyPerItemEx1 + commissionPerItemEx1;
        totalPayoutEx1 += itemPayout;
        const productName = key.charAt(0).toUpperCase() + key.slice(1);
        detailsHtmlEx1 += `
          <div class="grid-item-name">${productName}:</div>
          <div class="grid-item-royalty">Base <strong>Royalty</strong> ${currencySymbol}${basePrice} x ${royaltyRate * 100}% = <span class="accent-number">${formatCurrency(royaltyPerItemEx1)}</span>;</div>
          <div class="grid-item-commission">Affiliate <strong>Commission</strong> ${currencySymbol}${basePrice} x ${affiliateCommissionPercentage}% = <span class="accent-number">${formatCurrency(commissionPerItemEx1)}</span></div>
        `;
      }
    }
    detailsHtmlEx1 += '</div>';
    const cartTotalEx1 = selectedCountEx1 * basePrice;

    // --- Example 2 ---
    const premiumPrice = parseFloat(premiumPriceInput.value) || 0;
    const royaltyEx2 = basePrice * royaltyRate;
    let premiumCommissionEx2 = premiumPrice > basePrice
      ? (premiumPrice - basePrice) * premiumRate
      : 0;
    
      
    // premiumCommissionEx2 = isAffiliate ? premiumCommissionEx2 : 0;
    const commissionPerItemEx2 = isAffiliate ? standardAffiliateCommission : 0;
    const payoutEx2 = royaltyEx2 + commissionPerItemEx2 + premiumCommissionEx2;
    const detailsHtmlEx2 = `
      <div class="payout-details-grid-ex2">
        <div>Base <strong>Royalty</strong>:</div>
        <div>${formatCurrency(basePrice)} x ${royaltyRate * 100}% = <span class="accent-number">${formatCurrency(royaltyEx2)}</span></div>
        <div>Affiliate <strong>Commission</strong>:</div>
        <div><span class="accent-number">${formatCurrency(commissionPerItemEx2)}</span> (Fixed)</div>
        <div>Premium <strong>Profit Commission</strong>:</div>
        <div>(${formatCurrency(premiumPrice)} - ${formatCurrency(basePrice)}) x ${premiumRate * 100}% = <span class="accent-number">${formatCurrency(premiumCommissionEx2)}</span></div>
      </div>
    `;

    // --- Example 3 ---
    const cartTotalEx3 = 221.80;
    const otherItemsCostEx3 = cartTotalEx3 - basePrice;
    const royaltyEx3 = basePrice * royaltyRate;
    const otherItemsCommissionEx3 = isAffiliate ? otherItemsCostEx3 * otherItemsRate : 0;
    const commissionPerItemEx3 = isAffiliate ? standardAffiliateCommission : 0;
    const payoutEx3 = royaltyEx3 + commissionPerItemEx3 + otherItemsCommissionEx3;
    const detailsHtmlEx3 = `
      <div class="payout-details-grid-ex3">
        <div class="grid-header">1x Pro Product (${formatCurrency(basePrice)}):</div>
        <div class="indent">Base <strong>Royalty</strong> (${royaltyRate * 100}%):</div><div class="indent"><span class="accent-number">${formatCurrency(royaltyEx3)}</span></div>
        <div class="indent">Affiliate <strong>Commission</strong> (Fixed):</div><div class="indent"><span class="accent-number">${formatCurrency(commissionPerItemEx3)}</span></div>
        <div class="grid-header">Other Items (${formatCurrency(otherItemsCostEx3)}):</div>
        <div class="indent">Affiliate <strong>Commission</strong> (${otherItemsRate * 100}%):</div><div class="indent"><span class="accent-number">${formatCurrency(otherItemsCommissionEx3)}</span></div>
      </div>
    `;

    // Update DOM
    ex1CartTotalElement.textContent = formatCurrency(cartTotalEx1);
    payoutValueElements.ex1.textContent = formatCurrency(totalPayoutEx1);
    payoutValueElements.ex2.textContent = formatCurrency(payoutEx2);
    payoutValueElements.ex3.textContent = formatCurrency(payoutEx3);

    payoutDetailsElements.ex1.innerHTML = selectedCountEx1
      ? detailsHtmlEx1
      : '<div>Select a product above to see details.</div>';
    payoutDetailsElements.ex2.innerHTML = detailsHtmlEx2;
    payoutDetailsElements.ex3.innerHTML = detailsHtmlEx3;
  };

  // --- Event Listeners ---
  for (const tab of tabs) {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      isAffiliate = tab.dataset.source === 'affiliate';
      calculatePayouts();
    });
  }

  for (const option of ex1OptionElements) {
    option.addEventListener('click', () => {
      const key = option.dataset.product;
      selectedProductsEx1[key] = !selectedProductsEx1[key];
      option.classList.toggle('active', selectedProductsEx1[key]);
      calculatePayouts();
    });
  }

  for (const option of ex2OptionElements) {
    option.addEventListener('click', () => {
      const key = option.dataset.product;
      selectedProductsEx2[key] = !selectedProductsEx2[key];
      option.classList.toggle('active', selectedProductsEx2[key]);
      const newPayout = basePayoutEx2 * Object.values(selectedProductsEx2).filter(Boolean).length;
      payoutValueElements.ex2.textContent = formatCurrency(newPayout);
    });
  }

  premiumPriceInput.addEventListener('input', () => {
    if (parseFloat(premiumPriceInput.value) < 0) {
      premiumPriceInput.value = 0;
    }
    calculatePayouts();
  });

  premiumPriceInput.addEventListener('change', () => {
    let value = parseFloat(premiumPriceInput.value) || 0;
    if (value < 250.00) {
      value = 250.00;
      activatePopText();
    }
    premiumPriceInput.value = value.toFixed(2);
    calculatePayouts();
  });

  for (const toggleBtn of toggleDetailButtons) {
    const detailsId = toggleBtn.dataset.targetDetails;
    const detailsElement = document.getElementById(detailsId);
    const arrowEl = toggleBtn.querySelector('.arrow');

    const updateArrow = () => {
      const isIdle = detailsElement.classList.contains('idle');
      const currentHeight = detailsElement.offsetHeight;
      const targetHeight = isIdle ? detailsElement.scrollHeight : 0;

      arrowEl.textContent = isIdle ? '▲' : '▼';
      arrowEl.classList.toggle('down', !isIdle);
      arrowEl.classList.toggle('up', isIdle);

      if (isIdle) {
        detailsElement.style.height = `${currentHeight}px`;
        detailsElement.classList.remove('idle');
        gsap.to(detailsElement, {
          height: targetHeight,
          duration: 0.6,
          ease: 'sine.inOut',
          onComplete: () => { detailsElement.style.height = 'auto'; }
        });
      } else {
        detailsElement.style.height = `${currentHeight}px`;
        gsap.to(detailsElement, {
          height: targetHeight,
          duration: 0.6,
          ease: 'sine.inOut',
          onComplete: () => {
            detailsElement.classList.add('idle');
            detailsElement.style.height = '0';
          }
        });
      }
    };

    toggleBtn.addEventListener('click', updateArrow);
    // Initialize arrow state
    if (!detailsElement.classList.contains('idle')) updateArrow();
  }

  sidebarToggle.addEventListener('click', () => {
    const calcContainer = document.querySelector('.custom-earnings-calc');
    calcContainer.classList.toggle('idle');
    document.body.classList.toggle('idle');
  });

  for (const tabBtn of tabNumberElements) {
    tabBtn.addEventListener('click', () => {
      const currentExample = document.querySelector(`#calc-example-${calcContent.dataset.active}`);
      tabNumberElements.forEach(t => t.classList.remove('active'));
      tabBtn.classList.add('active');

      const startHeight = currentExample.offsetHeight;
      const targetIndex = [...tabNumberElements].indexOf(tabBtn) + 1;
      const targetExample = document.querySelector(`#calc-example-${targetIndex}`);

      calcContent.setAttribute('data-active', targetIndex);
      const newHeight = targetExample.scrollHeight;
      targetExample.style.height = `${startHeight}px`;

      const tl = gsap.timeline();
      tl.to(targetExample, {
        height: newHeight,
        duration: 0.6,
        ease: 'sine.inOut',
        onComplete: () => { targetExample.style.height = 'auto'; }
      })
        // .from(targetExample, {
        //   y: '-100%',
        //   duration: 0.6,
        //   ease: 'sine.out'
        // }, '<');
    });
  }

  // Initialize Ex1 option states
  for (const option of ex1OptionElements) {
    const key = option.dataset.product;
    option.classList.toggle('active', selectedProductsEx1[key]);
  }

  // Initial calculation
  calculatePayouts();
});
